const LOADER_ID = 'initial-loader';
const LOADER_TEXT_ID = 'initial-loader-text';
const LOADER_DESCRIPTION_ID = 'initial-loader-description';
const ERROR_TEXT = 'Something has gone wrong. Please try again.';

export class InitialLoaderService {
  protected static error = false;

  static showError(message?: string) {
    if (this.error) {
      return;
    }
    this.error = true;

    const textEl = document.getElementById(LOADER_TEXT_ID);
    if (textEl) {
      textEl.innerText = ERROR_TEXT;
    }
    if (message) {
      const descriptionEl = document.getElementById(LOADER_DESCRIPTION_ID);
      if (descriptionEl) {
        descriptionEl.innerText = message;
      }
    }
  }

  static hide() {
    document.getElementById(LOADER_ID)?.remove();
  }
}
